import { render, staticRenderFns } from "./InputEPMTimeAllocation.vue?vue&type=template&id=2d6200b2&scoped=true"
import script from "./InputEPMTimeAllocation.vue?vue&type=script&lang=js"
export * from "./InputEPMTimeAllocation.vue?vue&type=script&lang=js"
import style0 from "./InputEPMTimeAllocation.vue?vue&type=style&index=0&id=2d6200b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6200b2",
  null
  
)

export default component.exports